import superjson from "superjson";
import { SuperJSONResult } from "superjson/dist/types";

/**
 * Serializes data for server-side rendering using SuperJSON.
 * This function takes any data structure and converts it to a format that can be safely
 * passed from server to client during Next.js getServerSideProps or getStaticProps.
 *
 * @param data - The data to be serialized
 * @returns An object with props containing the serialized data
 */
export function serializeProps<T>(data: T) {
  return { props: superjson.serialize(data) };
}

/**
 * Deserializes data previously serialized with SuperJSON.
 * This function converts the serialized props back to their original data structure,
 * preserving types that JSON normally doesn't support (like Date, Map, Set, etc).
 *
 * @param props - The serialized props object from SuperJSON
 * @returns The original data structure with all types restored
 */
export function deserializeProps<T>(props: SuperJSONResult): T {
  // Note - ideally we shouldn't have to do this check. We need to figure out why
  // we're sometimes not getting serialized data where we expect it, but for now
  // this check prevents errors in those cases.
  if (props["json"]) {
    return superjson.deserialize<T>(props);
  }
  return props as T;
}
